module.exports = __webpack_public_path__ + "static/img/img7.ed8d3cef.png";